import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import FullPageLoader from 'components/FullPageLoader/FullPageLoader';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify'
import Pagination from 'rc-pagination';
import { Link } from 'react-router-dom'
import 'rc-pagination/assets/index.css';
import StaffModal from './staffModalComponent'
import localeInfo from 'rc-pagination/lib/locale/en_US';
import { Button, Card, Form, Table, Container, Row, Col, OverlayTrigger, Tooltip, Modal, FormGroup } from "react-bootstrap";
var CryptoJS = require("crypto-js");
import { ENV } from 'config/config';
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import Select from 'react-select'
import { useGetStaffAdminsQuery, useDeleteAdminMutation, useGetRolesQuery, useGetPermissionQuery } from '../../../redux/api';

const AdminStaff = () => {
    const [admins, setAdmins] = useState({})
    const [admin, setAdmin] = useState({})
    const [currentUserRole, setCurrentUserRole] = useState({})
    const [roleModal, setroleModal] = useState(false)
    const [modalType, setModalType] = useState()
    const [roles, setRoles] = useState()
    const [rolesOptions, setOptions] = useState([])
    const [search, setSearch] = useState('')
    const [searchLastName, setSearchLastName] = useState('')
    const [email, setEmail] = useState('')
    const [roleSearch, setRoleSearch] = useState('')
    const [searchStatus, setSearchStatus] = useState('')
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [pages, setPages] = useState(0)
    const [resetButton, setResetButton] = useState(false)
    const [total, setTotal] = useState(0)
    const adminId = localStorage.getItem('userID')
    const [flag, setFlag] = useState(false)
    const statusOptions = [
        { value: "1", label: 'Active' },
        { value: "0", label: 'Inactive' },
    ]
    const [qs, setQs] = useState('');
    const { data: adminsRes, isLoading: isAdminsLoading, isFetching: isAdminsFetching, refetch } = useGetStaffAdminsQuery(qs);
    const [deleteAdmin, { isLoading: isDeletingAdmin }] = useDeleteAdminMutation();
    // set modal type
    const setModal = (type = 1, admin = {}) => {
        setFlag((prevVal) => !prevVal)
        setroleModal(!roleModal)
        setModalType(type)
        // add category
        if ((type === 2 || type === 3) && admin) {
            setAdmin(admin)
        }
    }


    const deleteRoleHandler = (adminId) => {
        Swal.fire({
            title: 'Are you sure you want to delete?',
            html: 'If you delete a staff, it will lost permanently.',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete'
        }).then(async (result) => {
            if (result.value) {
                deleteAdmin(adminId).then(() => {
                    const nextQs = ENV.objectToQueryString({ page: 1, limit: 10, adminId })
                    setQs(nextQs)
                    refetch()
                })
            }
        })
    }

    const onSearch = () => {
        if (search || email || searchStatus || roleSearch || searchLastName) {
            setResetButton(true)
            const nextQs = ENV.objectToQueryString({ firstName: search.trim(), lastName: searchLastName.trim(), email: encodeURIComponent(email.trim()), isActive: searchStatus, roleId: roleSearch, page: 1, limit: 10, adminId })
            setQs(nextQs)
        }
        else {
            toast.error('All filters are empty.', {
                toastId: "FIELD_REQUIRED",
            })
        }
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onSearch();
        }
    }

    const reset = () => {
        setResetButton(false)
        setSearch('')
        setSearchLastName('')
        setEmail('')
        setRoleSearch('')
        setSearchStatus('')
        const nextQs = ENV.objectToQueryString({ page: 1, limit: 10, adminId })
        setQs(nextQs)
    }

    const onPageChange = (page) => {
        const nextQs = ENV.objectToQueryString({ title: search.trim(), email: email.trim(), status: searchStatus, roleId: roleSearch, page, limit, adminId })
        setQs(nextQs)
        // props.getStaffAdmins(page, limit, search, adminId)
    }

    const getData = () => {
        const nextQs = ENV.objectToQueryString({ page: 1, limit: 10, adminId: localStorage.getItem('userID') })
        setQs(nextQs)
    }

    useEffect(() => {
        let roleEncrypted = localStorage.getItem('role');
        if (roleEncrypted) {
            const qs = ENV.objectToQueryString({ page: 1, limit: 10, adminId: localStorage.getItem('userID') })
            setQs(qs)
        }
    }, [])

    const roleEncrypted = localStorage.getItem('role');
    const roleDecrypted = roleEncrypted ? CryptoJS.AES.decrypt(roleEncrypted, ENV.secretKey).toString(CryptoJS.enc.Utf8) : '';
    const { data: permissionData, isLoading: isPermissionLoading } = useGetPermissionQuery(roleDecrypted, { skip: !roleEncrypted })
    useEffect(() => {
        if (permissionData && permissionData.role?.permissions) {
            const perms = typeof permissionData.role.permissions === 'string' 
                ? JSON.parse(permissionData.role.permissions) 
                : permissionData.role.permissions;
            setCurrentUserRole(perms)
        }
    }, [permissionData])

    useEffect(() => {
        if (adminsRes) {
            setAdmins(adminsRes.users)
            setPage(adminsRes.page)
            setPages(adminsRes.pages)
            setLimit(adminsRes.limit)
            setTotal(adminsRes.total)
        }
    }, [adminsRes])

    useEffect(() => {}, [])


    const { data: rolesRes, isLoading: isRolesLoading } = useGetRolesQuery();
    useEffect(() => {
        if (rolesRes) {
            let data = rolesRes
            setRoles(data)
            let options = []
            if (data?.length) {
                data.map((d) => {
                    options.push({ value: d.id, label: d.title })
                })
            }
            setOptions(options)
        }
    }, [rolesRes])

    return (
        <>
            { (isAdminsLoading || isAdminsFetching || isDeletingAdmin || isPermissionLoading || isRolesLoading) ? <FullPageLoader /> : null }
            <Container fluid>
                <Row>
                    <Col md="12">
                        <Card className="filter-card card">
                            <Card.Header>
                                <div className="d-flex align-items-center justify-content-between table-head">
                                    <Card.Title as="h4">Filters</Card.Title>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col xl={4} sm={6} className="search-wrap">
                                        <Form.Group>
                                            <Form.Label className="d-block mb-2">Search with first name...</Form.Label>
                                            <Form.Control onKeyPress={handleKeyPress} name="search" placeholder="First Name" value={search} onChange={(e) => setSearch(e.target.value)}></Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col xl={4} sm={6} className="search-wrap">
                                        <Form.Group>
                                            <Form.Label className="d-block mb-2">Search with last name...</Form.Label>
                                            <Form.Control onKeyPress={handleKeyPress} name="searchLastName" placeholder="Last Name" value={searchLastName} onChange={(e) => setSearchLastName(e.target.value)}></Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col xl={4} sm={6} className="search-wrap">
                                        <Form.Group>
                                            <Form.Label className="d-block mb-2">Search with email...</Form.Label>
                                            <Form.Control onKeyPress={handleKeyPress} name="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}></Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col xl={4} sm={6} className="search-wrap">
                                        <label >Search with User Role...</label>
                                        <Form.Group>
                                            <Select
                                                classNamePrefix="triage-select"
                                                placeholder='Select Role'
                                                className="w-100"
                                                name="roleSearch"
                                                options={rolesOptions}
                                                onChange={(e) => setRoleSearch(e ? e.value : '')}
                                                value={rolesOptions.filter((r) => r.value === roleSearch)}
                                                isClearable
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xl={4} sm={6} className="search-wrap">
                                        <label >Search with status...</label>
                                        <Form.Group>
                                            <Select
                                                classNamePrefix="triage-select"
                                                placeholder='Select Status'
                                                name="status"
                                                options={statusOptions}
                                                onChange={(e) => setSearchStatus(e ? e.value : '')}
                                                value={statusOptions.filter((l) => l.value === searchStatus)}
                                                isClearable
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xl={4} md={6}>
                                        <Form.Group>
                                            <label className="d-none d-sm-block mb-2 form-label">&nbsp;</label>
                                            <div className="d-flex filter-btns-holder">
                                                <button type="button" className="btn-filled mr-3" onClick={onSearch} >
                                                    Search
                                                    {/* <i className="fa fa-search" /> */}
                                                </button>
                                                {resetButton && <button type="button" className="outline-button" onClick={reset}>Reset</button>}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <Card className="table-big-boy">
                            <Card.Header>
                                <div className="d-flex align-items-center justify-content-between table-head">
                                    <Card.Title as="h4">Staff</Card.Title>
                                    {/* <p className="card-category">List of Categories</p> */}
                                    {currentUserRole && currentUserRole.addStaff ?
                                        <Button className="btn-filled d-flex align-items-center" onClick={() => setModal(1)}>
                                            <span className='add-icon mr-2'>
                                                <FaPlus />
                                            </span>
                                            Add New Staff</Button>
                                        :
                                        ''
                                    }
                                </div>
                            </Card.Header>
                            <Card.Body className="table-full-width staff-table">
                                <div className="table-responsive">
                                    <Table className="table-bigboy ">
                                        <thead>
                                            <tr>
                                                <th className="td-start">#</th>
                                                <th className='td-name'>Name</th>
                                                <th className='td-image'>Image</th>
                                                <th className='td-email'>Email</th>
                                                <th className='td-role'>User Role</th>
                                                <th className="text-center td-status">Status</th>
                                                <th className="td-actions text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                admins && admins.length > 0 ?
                                                    admins.map((val, key) => {
                                                        return (
                                                            <tr key={key}>
                                                                <td className=''>{((limit * page) - limit) + key + 1}</td>
                                                                <td className=' td-name'>{val.firstName + ' ' + val.lastName}</td>
                                                                <td className=''>
                                                                    {val.photo && (
                                                                        <div className="d-flex justify-content-center">
                                                                            <div className="title-img-holder">
                                                                                <img className="img-fluid" src={ENV.assetsUrl + "users/" + val.photo} alt="User" />
                                                                            </div>
                                                                        </div>

                                                                    )}
                                                                </td>
                                                                <td className=' td-email'>{val.email}</td>
                                                                <td className=' td-role'>{val.Role.title}</td>
                                                                <td className='text-center'> {val.isActive ? (<span className='label label-success m-0'>Active</span>) : (<span className='label label-danger m-0'>Inactive</span>)} </td>
                                                                <td className="td-actions">
                                                                    <ul className="list-unstyled mb-0 d-flex">{
                                                                        currentUserRole?.viewStaff ?
                                                                            <li className="d-inline-block align-top">
                                                                                <OverlayTrigger overlay={<Tooltip id="tooltip-436082023" >View</Tooltip>} placement="left">
                                                                                    <button type="button" className="btn-link btn-icon btn btn-info" onClick={() => setModal(2, val)}><FaEye /></button>
                                                                                </OverlayTrigger>
                                                                            </li>
                                                                            : null
                                                                    }
                                                                        {currentUserRole?.editStaff ?
                                                                            <li className="d-inline-block align-top">
                                                                                <OverlayTrigger overlay={<Tooltip id="tooltip-436082023">Edit</Tooltip>} placement="left">
                                                                                    <button type="button" className="btn-link btn-icon btn btn-success" onClick={() => setModal(3, val)} disabled={val.id === localStorage.getItem('userID') || val.isSuperAdmin}>
                                                                                        <FaEdit />
                                                                                    </button>
                                                                                </OverlayTrigger>
                                                                            </li>
                                                                            : null
                                                                        }
                                                                        {
                                                                            currentUserRole?.deleteStaff ?
                                                                                <li className="d-inline-block align-top">
                                                                                    <OverlayTrigger overlay={<Tooltip id="tooltip-436082023">Delete</Tooltip>} placement="left">
                                                                                        <button type="button" className="btn-link btn-icon btn btn-danger" onClick={() => deleteRoleHandler(val.id)} disabled={val.id === localStorage.getItem('userID') || val.isSuperAdmin}>
                                                                                            <FaTrash />
                                                                                        </button>
                                                                                    </OverlayTrigger>
                                                                                </li>
                                                                                : null
                                                                        }
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td className="text-center px-0" colSpan="6">
                                                            <span className="alert alert-info d-block text-center">No Record Found</span>
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </Table>
                                    <Col className="pb-4">
                                        <Pagination
                                            defaultCurrent={1}
                                            pageSize // items per page
                                            current={page} // current active page
                                            total={pages} // total pages
                                            onChange={onPageChange}
                                            locale={localeInfo}
                                        />
                                    </Col>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <StaffModal flag={flag} getData={getData} modalType={modalType} setModalType={setModalType} roleModal={roleModal} setroleModal={setroleModal} admin={admin} roles={roles} />
            </Container>
        </>
    )
}

export default AdminStaff;
